import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { SetupMembershipPageRoutingModule } from './setup-membership-routing.module';

import { SetupMembershipPage } from './setup-membership.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SetupMembershipPageRoutingModule
  ],
  declarations: [SetupMembershipPage]
})
export class SetupMembershipPageModule {}
